"use client";
import { jsx as t } from "react/jsx-runtime";
import { Paper as p, sharedHandler as f } from "@ingeniorforeningen/figurine-core";
import { forwardRef as u } from "react";
import d from "./variants/ClusterItemFile.js";
import C from "./variants/ClusterItemLocation.js";
import I from "./variants/ClusterItemTopic.js";
import '../../../assets/ClusterItem.css';const N = "_root_15ta2_2", y = {
  root: N
}, e = u((s, m) => {
  const { variant: r = "location", className: a, link: i, icon: l, text: c, ...n } = s, o = { link: i, icon: l, text: c };
  return /* @__PURE__ */ t(p, { ...n, p: 0, className: `${y.root} ${a}`, ref: m, children: r === "file" ? /* @__PURE__ */ t(d, { ...o }) : r === "topic" ? /* @__PURE__ */ t(I, { ...o }) : /* @__PURE__ */ t(C, { ...o }) });
});
e.displayName = "ClusterItem";
const _ = f(e);
_.displayName = e.displayName;
export {
  y as C,
  e as _ClusterItem,
  _ as default
};
